<script setup>
	import { isExternalUrl } from 'shared/services/urlTypeService';
	import { DsButton, DsButtonPlay, dsUseIsMobile } from '@coloplast/design-system';
	import '@coloplast/design-system/dist/components/button/ds-button-play.css';
	import { track_content_engagement } from 'shared/services/tracking/contentTrackingService';
	import {
		computed,
	} from 'vue';

	const props = defineProps({
		item: {
			type: Object,
			required: true,
		},
	})

	const { isMobile } = dsUseIsMobile();

	const emit = defineEmits(['clicked']);

	const checkIfExternalUrl = computed(() => isExternalUrl(props.item.CtaButtonLinkUrl) ? '_blank' : '_self');

	function setVideoUrl(url) {
		emit('clicked', url);
		track_content_engagement('video', 'start', props.item.Headline || 'no_data', props.item.VideoUrl);
	}
</script>

<template>
	<article class="c-quick-links__content-item"
			 :class="[{ 'no-media' : !item.ImageUrl && !item.VideoUrl }, item.ImageAlignment]">
		<div class="c-quick-links__content-text">
			<div class="c-quick-links__content-wrapper"
				 :class="{ 'with-media': item.ImageUrl || item.VideoUrl }">
				<h2 class="c-quick-links__content-headline"
					v-if="item.Headline"
					v-html="item.Headline">
				</h2>
				<p class="c-quick-links__content-description"
				   v-if="item.Description"
				   v-html="item.Description">
				</p>
				<div v-if="item.CtaButtonLinkUrl" class="c-quick-links__content-cta">
					<DsButton :href="item.CtaButtonLinkUrl"
							   :target="checkIfExternalUrl"
							   variant="primary">
						{{ item.CtaButtonText }}
					</DsButton>
				</div>
			</div>
		</div>
		<div class="c-quick-links__content-media"
			 v-if="item.ImageUrl || item.VideoUrl">
			<img v-if="item.ImageUrl"
				 :src="item.ImageUrl"
				 :alt="item.ImageAltText || item.Headline"
				 class="c-quick-links__content-image" />
			<div v-if="item.VideoUrl"
				 class="c-content-library-card__playcontainer"
			>
				<DsButtonPlay
					aria-label-play="Play video"
					:size="isMobile ? 'md' : 'lg'"
					:play-handler="() => setVideoUrl(item.VideoUrl)"
				/>
			</div>
		</div>
	</article>
</template>
